const style = () => ({
    noResulteContainer: {
        height: '100%',
        alignItems: 'center',
        overflow: 'hidden'
    }
});
export default style;